<template>
<div class="xin">
    <div class="switch">

        <!-- 查询框 -->
        <div class="main">
            <el-form ref="form" :model="form" label-width="80px">
                <!-- 发件账户查询 -->

                <el-button @click="tan1()"> {{ $t("list.sender") }}</el-button>
                <!-- 收件账户查询 -->

                <el-button @click="tan2()">{{ $t("list.receiver") }}</el-button>
                <!-- 本地发信失败 -->

                <el-button @click="tan3()">{{ $t("list.sender1") }}</el-button>
                <!-- 本地发信失败 -->

                <el-button @click="off_return()">{{ $t("logs.Policy_back") }}</el-button>
            </el-form>
        </div>

        <!--  表格 -->

        <div class="table table_one" v-show="bi1">
            <el-table v-loading="loading" :data="fileList" :row-class-name="tableRowClassName" ref="multipleTable1" :cell-class-name="tableCellClassName" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="40" v-model="multipleSelection"></el-table-column>

                <el-table-column :label="$t('table.tls')" width="40">
                    <template slot-scope="scope">
                        <img v-if="scope.row.SHOWTLS == 1" src="/imgs/tls.png" alt title="tls"/>
                        <img v-if="scope.row.SHOW_WL == 1" src="/imgs/wls.png" alt :title="$t('table.wl')"/>
                    </template>
                </el-table-column>
                <el-table-column prop="AC_DATE" :label="$t('table.maildate')" width="100"></el-table-column>
                <el-table-column prop="SHOW_MINION" :label="$t('table.clusterhost')" width="96"></el-table-column>
                <el-table-column prop="QID" :label="$t('table.ID')" width="120"></el-table-column>
                <el-table-column prop="IP" :label="$t('table.IP')" width="102"></el-table-column>
                <!--  发件人 -->

                <el-table-column prop="ENVFROM" :label="$t('table.ENVFROM')" width="160">
                    <template slot-scope="scope">

                        <el-tooltip class="item" effect="dark" :content="scope.row.ENVFROM" placement="top">
                            <span> {{ scope.row.SHOW_ENVFROM }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="NRCPT" :label="$t('table.ENVRCPT1')" width="68"></el-table-column>
                <!--  收件人 -->

                <el-table-column prop="ENVRCPT" :label="$t('table.ENVRCPT')" width="110">
                    <template slot-scope="scope">

                        <el-tooltip class="item" effect="dark" :content="scope.row.SHOW_MORE_RCPT" placement="top">
                            <span> {{ scope.row.ENVRCPT }}</span>
                        </el-tooltip>
                    </template>

                </el-table-column>

                <el-table-column prop="SUBJECT" :label="$t('table.SUBJECT')" :show-overflow-tooltip="true">

                  

                </el-table-column>
                <el-table-column prop="SIZE" :label="$t('table.mailsize')" width="64"></el-table-column>
                <el-table-column prop="STATUS" :label="$t('table.status')" width="80">
                    
                </el-table-column>
            </el-table>
            
        </div>
        <!--  表格 -->

        <div class="table table_two" v-show="bi2">
            <el-table v-loading="loading_send" :data="fileList" :row-class-name="tableRowClassName" ref="multipleTable" :cell-class-name="tableCellClassName" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="40" v-model="multipleSelection">
                </el-table-column>
                <el-table-column :label="$t('table.tls')" width="40">
                    <template slot-scope="scope">
                        <img v-if="scope.row.SHOWTLS == 1" src="/imgs/tls.png" alt title="tls"/>
                        <img v-if="scope.row.SHOW_WL == 1" src="/imgs/wls.png" alt :title="$t('table.wl')"/>
                    </template>
                </el-table-column>
                <el-table-column prop="AC_DATE" :label="$t('table.maildate')" width="96"></el-table-column>
                <el-table-column prop="SHOW_MINION" :label="$t('table.clusterhost')" width="96"></el-table-column>

                <el-table-column prop="IP" :label="$t('table.IP')" width="96"></el-table-column>
                <el-table-column prop="SENDER" :label="$t('table.ENVFROM')" width="160">
<template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.SENDER"
                  placement="top"
                >
                  <span> {{ scope.row.SHOW_ENVFROM }}</span>
                </el-tooltip>
              </template>
                </el-table-column>

                <el-table-column prop="ENVRCPT" :label="$t('table.ENVRCPT')" width="160">
<template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.ENVRCPT"
                  placement="top"
                >
                  <span> {{ scope.row.SHOW_ENVRCPT }}</span>
                </el-tooltip>
                  </template>
                </el-table-column>

                <el-table-column prop="SUBJECT" :label="$t('table.SUBJECT')">
                         <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.SUBJECT"
                  placement="top"
                >
                  <span> {{ scope.row.SHOW_SUBJECT }}</span>
                </el-tooltip>
                  </template>
                </el-table-column>

                <el-table-column prop="STATUS" :label="$t('table.status')" width="94">

                     <template slot-scope="scope">
                             <span v-if="scope.row.SENT==1"> {{
                          scope.row.STATUS 
                        }}</span>
                            <el-popover
                            v-if="scope.row.SENT==0"
    placement="left"
    title=""
    width="200"
    trigger="hover"
    :content="scope.row.REASON">
        <span slot="reference">{{
                          scope.row.STATUS 
                        }}</span>
  </el-popover>
                            </template>
                </el-table-column>
                <el-table-column prop="RELAY" :label="$t('table.relay')" width="160"></el-table-column>
            </el-table>
        </div>
        <!--  表格 -->

        <div class="table table_three" v-show="bi3" v-loading="loading_send">
            <el-table v-loading="loading" :data="fileList" :row-class-name="tableRowClassName" ref="multipleTable" :cell-class-name="tableCellClassName" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="40" v-model="multipleSelection">
                </el-table-column>
                <el-table-column :label="$t('table.tls')" width="40">
                    <template slot-scope="scope">
                        <img v-if="scope.row.SHOWTLS == 1" src="/imgs/tls.png" alt title="tls"/>
                        <img v-if="scope.row.SHOW_WL == 1" src="/imgs/wls.png" alt :title="$t('table.wl')"/>
                    </template>
                </el-table-column>
                <el-table-column prop="AC_DATE" :label="$t('table.maildate')" width="96"></el-table-column>
                <el-table-column prop="SHOW_MINION" :label="$t('table.clusterhost')" width="96"></el-table-column>

                <el-table-column prop="IP" :label="$t('table.IP')" width="96"></el-table-column>
                <el-table-column prop="SENDER" :label="$t('table.ENVFROM')" width="160">
<template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.SENDER"
                  placement="top"
                >
                  <span> {{ scope.row.SHOW_ENVFROM }}</span>
                </el-tooltip>
              </template>

                </el-table-column>

                <el-table-column prop="ENVRCPT" :label="$t('table.ENVRCPT')" width="160">
<template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.ENVRCPT "
                  placement="top"
                >
                  <span> {{ scope.row.SHOW_ENVRCPT }}</span>
                </el-tooltip>
                  </template>
                </el-table-column>

                <el-table-column prop="SUBJECT" :label="$t('table.SUBJECT')">

                    <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.SUBJECT"
                  placement="top"
                >
                  <span> {{ scope.row.SHOW_SUBJECT }}</span>
                </el-tooltip>
                  </template>
                </el-table-column>

                <el-table-column prop="STATUS" :label="$t('table.status')" width="94">
                     <template slot-scope="scope">
                             <span v-if="scope.row.SENT==1"> {{
                          scope.row.STATUS 
                        }}</span>
                            <el-popover
                            v-if="scope.row.SENT==0"
    placement="left"
    title=""
    width="200"
    trigger="hover"
    :content="scope.row.REASON">
        <span slot="reference">{{
                          scope.row.STATUS 
                        }}</span>
  </el-popover>
                            </template>
                </el-table-column>
                <el-table-column prop="RELAY" :label="$t('table.relay')" width="160"></el-table-column>
            </el-table>
        </div>
        <!--  表格 -->

        <div class="table" v-show="bi4" v-loading="loading">
            <el-table v-loading="loading" :data="fileList" :row-class-name="tableRowClassName" ref="multipleTable" :cell-class-name="tableCellClassName" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">

                <el-table-column prop="AC_DATE" :label="$t('table.maildate')" width="126"></el-table-column>

                <el-table-column prop="ENVFROM" :label="$t('table.ENVFROM')" width="180"></el-table-column>

                <el-table-column prop="ENVRCPT" :label="$t('table.ENVRCPT')" width="180">
                </el-table-column>
                <el-table-column prop="SUBJECT" :label="$t('table.SUBJECT')" width="180"></el-table-column>

                <el-table-column prop="REASON" :label="$t('table.reason')">
                    
                </el-table-column>

            </el-table>
        </div>
        <!--  分页 -->
        <div class="fenye" v-show="xian6">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="page" :page-sizes="[10, 20, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="totalnums"></el-pagination>
              <el-button
            @click="derived_record"
            style="color:#fff"
            :disabled="$root.jurisdiction.only_query == 0"
           
          >
            {{ $t("table1.export_email") }}
          </el-button>
        </div>
           <div class="pop-up " v-show="derived_show"  v-drag="{ handle: '.pop_up_text_derived_record' }"
            >
              <!--  导出-->
              <div class="pop_up_text pop_up_text_derived_record">
                <span style="padding:0 14px"></span>{{ $t("table.record") }}
              </div>
              <p></p>
              <div class="find">
               
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px;">
                    <!-- 条数 -->
                    {{ $t("logs.derived") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="limit_cn" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px;">
                    <!-- 类型 -->
                    {{ $t("logs.smtpIp6") }}:
                  </div>
                  <div class="block block1">
                    <el-select
                      v-model="printtype"
                      placeholder=""
                     
                    >
                      <el-option
                        v-for="item in printtype_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                
                
               
                
               
               
              </div>

              <el-row>
                <el-button type="primary" @click="derived_unit" v-show=" xian6">{{
                  $t("logs.report16")
                }}</el-button>
                <el-button type="primary" @click="derived_unit_send" v-show=" bi2_show">{{
                  $t("logs.report16")
                }}</el-button>
                <el-button type="primary" @click="derived_unit_rec" v-show=" bi3_show">{{
                  $t("logs.report16")
                }}</el-button>
               
                <el-button type="danger" @click="derived_cancel">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="derived_show"></div>
        <!--  分页 -->
           <div class="fenye" v-show="bi2_show">
            <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2" :current-page.sync="page" :page-sizes="[10, 20, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="totalnums"></el-pagination>
              <el-button
            @click="derived_record"
            style="color:#fff"
            :disabled="$root.jurisdiction.only_query == 0"
           
          >
            {{ $t("table1.export_email") }}
          </el-button>
        </div>
        <!--  分页 -->
        <div class="fenye" v-show="bi3_show">
            <el-pagination @size-change="handleSizeChange3" @current-change="handleCurrentChange3" :current-page.sync="page" :page-sizes="[10, 20, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="totalnums"></el-pagination>
               <el-button
            @click="derived_record"
            style="color:#fff"
            :disabled="$root.jurisdiction.only_query == 0"
           
          >
            {{ $t("table1.export_email") }}
          </el-button>
        </div>
        <!--  分页 -->
        <!-- <div class="fenye" v-show="bi4_show">
            <el-pagination @size-change="handleSizeChange4" @current-change="handleCurrentChange4" :current-page.sync="page" :page-sizes="[10, 20, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="totalnums"></el-pagination>
        </div>-->

    </div>
    <div class="pop-up" v-show="tanchu1" v-drag ="{ handle: '.pop_up_text_ipcor' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_ipcor"><span class="span_pad"></span> {{$t('logs.sender_query')}}</div>
                        <p></p>
       
        <div class="find">
            <div class="find1">
                <div class="find-text" style="padding-right:12px">
                    Email :
                </div>
                <div class="block block1">
                    <el-input v-model="col.email" placeholder="请输入Email"></el-input>

                </div>
            </div>
        </div>

        <el-row>
            <el-button type="primary" @click="save1()">{{$t('confirm.search')}}</el-button>
            <el-button type="danger" @click="save12()">{{$t('logs.save_b')}}</el-button>
        </el-row>
    </div>
    <!-- 弹出框1-->

    <!-- 弹出框2-->
    <div class="pop-up" v-show="tanchu2" v-drag="{ handle: '.pop_up_text_tls_address' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_tls_address"><span class="span_pad"></span> {{$t('logs.sender_query1')}}</div>
                        <p></p>
        <div class="find">
            <div class="find1">
                <div class="find-text" style="padding-right:12px">
                    Email :
                </div>
                <div class="block block1">
                    <el-input v-model="col.email" placeholder="请输入Email"></el-input>

                </div>
            </div>
        </div>

        <el-row>
            <!-- 查询-->

            <el-button type="primary" @click="save2">{{ $t("confirm.search") }}
            </el-button>
            <!-- 取消-->

            <el-button type="danger" @click="save22">{{ $t("confirm.cancel") }}</el-button>
        </el-row>

    </div>
    <!-- 弹出框3-->
    <div class="table" v-show="tanchu3">
        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%">
            <el-table-column prop="name" label="时间"> </el-table-column>

            <el-table-column prop="address" label="发件人"></el-table-column>
            <el-table-column prop="address" label="收件人"> </el-table-column>
            <el-table-column prop="address" label="邮件主题"> </el-table-column>

            <el-table-column prop="address" label="发送失败原因"> </el-table-column>
        </el-table>
    </div>
    <div class="gray" v-show="tanchu"></div>
</div>
</template>

<script>
export default {
    data() {
        return {
               limit_cn_old:'',
       limit_cn:'',
      printtype:'pdf',
      printtype_arr:[],
      derived_show:false,
      derived_show1:false,
      derived_show2:false,
            bi1: true,
            bi2: false,
            bi3: false,
            bi4: false,
            bi2_show: false,
            bi3_show: false,
            bi4_show: false,
            fileList: [],
            col: {
                email: "",
            },
            // 总数
            totalnums: 0,
            size: 0,
            // 每页条数
            pagesize: 0,
            //   默认前往第几页
            page: 1,
            xian6: true,
            xian: false,
            btnText: "展示更多",
            multipleSelection: [],
            selectList: [], // 选中的数据
            excelData: [],
            allSelect: false,
            isIndeterminate: true,
            email: '',
            form: {
                username: "",
            },
            value: "",
            value1: [new Date(2020, 5, 10, 10, 10), new Date(2020, 6, 11, 10, 10)],
            tanchu: false,
            tanchu1: false,
            tanchu2: false,
            tanchu3: false,
            tanchu4: true,

            loading: false,
            loading_send:false,
            date_type: '',
            col_search:[],
        };
    },
    mounted() {
        this.getFileList();
    },
    created() {
        // console.log(147);
     
        // console.log(this.page)
        // this.col.page = this.page;
        // // this.col.totalnums = this.$route.params.totalnums
        // this.col = this.$route.params.col || this.col;

        // console.log(this.totalnums)

        // this.getFileList();
    },
    methods: {
          derived_unit_rec() {
            //   alert(3)

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      console.log(sid);
        console.log(this.col_search)
      let col_derived = JSON.parse(JSON.stringify(this.col_search));
   
      col_derived.limit_cn = this.limit_cn;
      col_derived.printtype = this.printtype;
      col_derived.printtofile = 1;
      col_derived.email = this.col.email;
      let col = JSON.stringify(col_derived);

      if (this.printtype == "csv") {
        let __mode = "download_query_rcptmsg";
        window.open(
          `/api/adm/cgi/mon.cgi?__mode=${__mode}&sid=${sid}&col=${col}`
        );
      }
      if (this.printtype == "html" || this.printtype == "pdf") {
        let __mode = "query_rcptmsg";

        window.open(
          `/api/adm/cgi/mon.cgi?__mode=${__mode}&sid=${sid}&col=${col}`
        );
      }
      this.derived_show = false;
    },
          derived_unit_send() {
            //   alert(2)
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      console.log(sid);
        console.log(this.col_search)
      let col_derived = JSON.parse(JSON.stringify(this.col_search));
   col_derived.email = this.col.email;
      col_derived.limit_cn = this.limit_cn;
      col_derived.printtype = this.printtype;
      col_derived.printtofile = 1;
      let col = JSON.stringify(col_derived);

      if (this.printtype == "csv") {
        let __mode = "download_query_sendmsg";
        window.open(
          `/api/adm/cgi/mon.cgi?__mode=${__mode}&sid=${sid}&col=${col}`
        );
      }
      if (this.printtype == "html" || this.printtype == "pdf") {
        let __mode = "query_sendmsg";

        window.open(
          `/api/adm/cgi/mon.cgi?__mode=${__mode}&sid=${sid}&col=${col}`
        );
      }
      this.derived_show = false;
    },
          // 导出记录事件
    derived_unit() {
        // alert(1)
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      console.log(sid);
        console.log(this.col_search)
      let col_derived = JSON.parse(JSON.stringify(this.col_search));
   
      col_derived.limit_cn = this.limit_cn;
      col_derived.printtype = this.printtype;
      col_derived.printtofile = 1;
      let col = JSON.stringify(col_derived);

      if (this.printtype == "csv") {
        let __mode = "download_queue";
        window.open(
          `/api/adm/cgi/mon.cgi?__mode=${__mode}&sid=${sid}&col=${col}`
        );
      }
      if (this.printtype == "html" || this.printtype == "pdf") {
        let __mode = "show_queue";

        window.open(
          `/api/adm/cgi/mon.cgi?__mode=${__mode}&sid=${sid}&col=${col}`
        );
      }
      this.derived_show = false;
    },
    // 取消导出
    derived_cancel() {
      this.derived_show = false;
    },
    // 导出记录
    derived_record() {
      this.derived_show = true;
      this.limit_cn = this.limit_cn_old;
       console.log(this.limit_cn)
    },
        // 初始化
        off_return() {
            this.xian6 = true
            this.bi1 = true
            this.bi2 = false
            this.bi3 = false
            this.bi4 = false
            this.bi2_show = false
            this.bi3_show = false

            this.getFileList();
        },
        // 1
        save1() {
            // this.loading_send=true;
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件
            // this.col.page=1
            // this.col.pagesize=this.col_search.pagesize
            let col = this.col;
            console.log(col, "5555", this.col);

            this.$axios
                .get("/api/adm/cgi/mon.cgi", {
                    params: {
                        __mode: "query_sendmsg",
                        sid: sid,
                        col: col,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res);
            this.loading_send=false;

                    // console.log(col, "传的col值");
                    // this.col1 = this.col;
                    // console.log(this.col1, "传的col1值");
                    // console.log(this.page, '222')

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        alert("请重新登录");
                        sessionStorage.removeItem("usermsg");
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                         this.bi1 = false
            this.bi3 = false
            this.bi4 = false
            this.bi2 = true
            this.tanchu1 = false;
            this.tanchu = false;
            this.xian6 = false

           
            this.bi2_show = true
            this.bi3_show = false
                        this.fileList = res.data.ret.datalist;
                        this.totalnums = res.data.ret.col.totalnums;
                        this.size = res.data.ret.col.pagesize;
                        this.page = res.data.ret.col.page;
                    
                    }
                })
               
        },
        save12() {
            this.tanchu1 = false;
            this.tanchu = false;
        },
        // 2
        save2() {
           
                       
            // this.loading_send=true;
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件
            //   this.col.page=1
            // this.col.pagesize=this.col_search.pagesize
            let col = this.col;
            console.log(col, "5555");

            this.$axios
                .get("/api/adm/cgi/mon.cgi", {
                    params: {
                        __mode: "query_rcptmsg",
                        sid: sid,
                        col: col,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res);
            this.loading_send=false;

                    // console.log(col, "传的col值");
                    // this.col1 = this.col;
                    // console.log(this.col1, "传的col1值");
                    // console.log(this.page, '222')

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        alert("请重新登录");
                        sessionStorage.removeItem("usermsg");
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                         this.bi1 = false
            this.bi2 = false
            this.bi4 = false

            this.bi3 = true
            this.tanchu2 = false;
            this.tanchu = false;
            this.xian6 = false
             this.bi2_show = false
                        this.bi3_show = true
                        this.fileList = res.data.ret.datalist;
                        this.totalnums = res.data.ret.col.totalnums;
                        this.size = res.data.ret.col.pagesize;
                        this.page = res.data.ret.col.page;
                     
                        // console.log(this.col.startdate);
                    }
                })
               
        },
        save22() {
            this.tanchu2 = false;
            this.tanchu = false;
        },
        // 2
        tan3() {
            this.bi1 = false
            this.bi2 = false
            this.bi3 = false
            this.bi4 = true
            this.tanchu2 = false;
            this.tanchu = false;
            this.xian6 = false
            this.loading = true
           this.bi2_show = false
                        this.bi3_show = false
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件
            this.col.email=''
            this.col.page=''
            this.col.pagesize=''
            let col = this.col;
            console.log(col, "5555");

            this.$axios
                .get("/api/adm/cgi/mon.cgi", {
                    params: {
                        __mode: "show_sender_fail",
                        sid: sid,
                        col: col,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res);
                    // console.log(col, "传的col值");
                    // this.col1 = this.col;
                    // console.log(this.col1, "传的col1值");
                    // console.log(this.page, '222')

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading = false

                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading = false

                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        alert("请重新登录");
                        sessionStorage.removeItem("usermsg");
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false
                        this.fileList = res.data.ret.datalist;
                        this.totalnums = res.data.ret.col.totalnums;
                        this.size = res.data.ret.col.pagesize;
                        this.page = res.data.ret.col.page;
                        // console.log(this.col.startdate);
                    }
                })
               
        },
        // 原始日志
        tan1: function () {
            this.tanchu = true;
            this.tanchu1 = true;
            this.tanchu4 = true;
            this.tanchu3 = false;
            this.col.email = ''
            this.col.page=1;

        },
        tan2: function () {
            this.tanchu = true;
            this.tanchu2 = true;
            this.tanchu4 = true;
            this.tanchu3 = false;
            this.col.email = '';
            this.col.page=1;

        },

        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
            this.tanchu1 = false;
            this.tanchu2 = false;
            this.tanchu3 = false;
        },
        tanOff: function () {
            this.tanchu = false;
            this.tanchu1 = false;
            this.tanchu2 = false;
            this.tanchu3 = false;
        },
        // 批量放行

        bulkpass() {
            if (this.multipleSelection.length === 0) {
                this.$message({
                    message: "请至少勾选一项，再进行操作",
                    type: "warning",
                });
                return;
            } else {
                this.loading = true;

                let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                console.log(sid);
                // console.log(this)
                // 获取表单数据,搜索条件
                let col = this.col;

                var arr = this.multipleSelection;
                // console.log(arr, "全选后，获取的数组");
                let multis = [];
                for (var i = 0; i < arr.length; i++) {
                    multis.push(arr[i].SEL_ID);
                }
                console.log(multis, "选中后的批量放行id");
                let multis1 = JSON.stringify(multis);
                this.$axios
                    .get("/api/adm/cgi/elkspam.cgi", {
                        params: {
                            __mode: " elk_archive_delete",
                            sid: sid,
                            col: col,

                            // bulkpassflag: 1,
                            msg_json: multis1,
                            // screen: "real_filterlog.html",
                        },
                    })
                    .then((res) => {
                        console.log(res);
                       if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                            alert(res.data);
                        } else if (res.data.fmstatus.code == "2") {
                            alert(res.data.fmstatus.errmsg);
                           this.loading=false
                        } else if (res.data.fmstatus.code == "3") {
                            alert(res.data.fmstatus.errmsg);
                            this.$router.push({
                                name: "login",
                            });
                        } else {
                            this.fileList = res.data.ret.datalist;

                            this.totalnums = res.data.ret.col.totalnums;
                            this.size = res.data.ret.col.pagesize;
                            this.loading = false;
                        }
                    })
                    .catch((err) => {
                        console.log("接口错误");
                        console.log(err);
                        alert(err);
                    });
            }
        },

        // 全部下载
        openPostWindow() {
            if (this.multipleSelection.length === 0) {
                this.$message({
                    message: "请至少勾选一项，再进行操作",
                    type: "warning",
                });
                return;
            } else {
                var arr = this.multipleSelection;
                console.log(arr, "全选后，获取的数组");
                let multis = [];
                for (var i = 0; i < arr.length; i++) {
                    multis.push(arr[i].SEL_ID);
                }
                // console.log(multis, "选中后的id");

                let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                var tempForm = document.createElement("form");
                tempForm.id = "tempForm1";
                tempForm.method = "post";
                tempForm.action = "/api/adm/cgi/elkspam.cgi?";
                tempForm.target = "_blank"; //打开新页面
                var hideInput1 = document.createElement("input");
                hideInput1.type = "hidden";
                hideInput1.name = "__mode"; //后台要接受这个参数来取值
                hideInput1.value = "elk_archive_downzip"; //后台实际取到的值
                var hideInput2 = document.createElement("input");
                hideInput2.type = "hidden";
                hideInput2.name = "sid";
                hideInput2.value = `${sid}`;
                var hideInput3 = document.createElement("input");
                hideInput3.type = "hidden";
                hideInput3.name = "msg_json";
                hideInput3.value = `${multis}`;
                // 这里就是如果需要第二个参数的时候可以自己再设置;
                tempForm.appendChild(hideInput1); //tempForm.appendChild(hideInput2);
                tempForm.appendChild(hideInput2); //tempForm.appendChild(hideInput2);
                tempForm.appendChild(hideInput3); //tempForm.appendChild(hideInput2);
                if (document.all) {
                    tempForm.attachEvent("onsubmit", function () {}); //IE
                } else {
                    // var subObj = tempForm.addEventListener("submit", function () {}, false); //firefox
                }
                document.body.appendChild(tempForm);
                if (document.all) {
                    tempForm.fireEvent("onsubmit");
                } else {
                    tempForm.dispatchEvent(new Event("submit"));
                }
                tempForm.submit();
                document.body.removeChild(tempForm);
            }
        },

        downloadExcel() {
            this.$confirm("确定下载列表文件?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    this.excelData = this.selectData; //你要导出的数据list。
                    this.exportExcel();
                })
                .catch(() => {});
        },

        //  getdatatime() {
        //   //默认显示今天
        //   this.value2 = new Date();
        // },
        // 格式化时间，获取当前时间的一个月后的时间值
        Date() {
            var seperator1 = "-";

            var data = new Date();
            var Da = new Date(data.getTime());
            // 以上两行代码为关键代码，若想要返回一天后的时间，则可以将第二行代码更换为下面代码
            // var Da = new Date(data.getTime() + 24 * 60 * 60 * 1000);
            // 若是想要返回值为当前时间，则上面两行代码可以直接修改为下面代码即可。
            // var Da = new Date()
            var year = Da.getFullYear();
            var month = Da.getMonth() + 1;
            var hour = Da.getHours();
            var minutes = Da.getMinutes();
            var seconds = Da.getSeconds();
            var strDate = Da.getDate();

            if (hour >= 1 && hour <= 9) {
                hour = "0" + hour;
            }
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            if (seconds >= 1 && seconds <= 9) {
                seconds = "0" + seconds;
            }
            if (minutes >= 0 && minutes <= 9) {
                minutes = "0" + minutes;
            }
            return (
                year +
                seperator1 +
                month +
                seperator1 +
                strDate +
                " " +
                hour +
                ":" +
                minutes +
                ":" +
                seconds
            );
        },
        // 七天前日期
        convertToLateDate() {
            var data = new Date();
            var Da = new Date(data.getTime() - 24 * 60 * 60 * 1000 * 7);
            var seperator1 = "-";
            // 以上两行代码为关键代码，若想要返回一天后的时间，则可以将第二行代码更换为下面代码
            // var Da = new Date(data.getTime() + 24 * 60 * 60 * 1000);
            // 若是想要返回值为当前时间，则上面两行代码可以直接修改为下面代码即可。
            // var Da = new Date()
            // var y = Da.getFullYear();
            // var m = Da.getMonth() + 1;
            // var d = Da.getDate();
            // var H = Da.getHours();
            // var mm = Da.getMinutes();
            // m = m < 10 ? "0" + m : m;
            // d = d < 10 ? "0" + d : d;
            // H = H < 10 ? "0" + H : H;
            // return y + "-" + m + "-" + d + " " + H + ":" + mm;
            var year = Da.getFullYear();
            var month = Da.getMonth() + 1;
            var hour = Da.getHours();
            var minutes = Da.getMinutes();
            var seconds = Da.getSeconds();
            var strDate = Da.getDate();
            if (hour >= 1 && hour <= 9) {
                hour = "0" + hour;
            }
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            if (seconds >= 1 && seconds <= 9) {
                seconds = "0" + seconds;
            }
            if (minutes >= 0 && minutes <= 9) {
                minutes = "0" + minutes;
            }
            return (
                year +
                seperator1 +
                month +
                seperator1 +
                strDate +
                " " +
                hour +
                ":" +
                minutes +
                ":" +
                seconds
            );
        },
        //打包下载
        // speedupCheckbox() {
        //   if (this.multipleSelection.length === 0) {
        //     this.$message({
        //       message: "请至少勾选一项，再进行操作",
        //       type: "warning",
        //     });
        //     return;
        //   } else {
        //     // this. openPostWindow()
        //     // this.speedupData();
        //     // this.exportExcel();
        //   }
        // },
        // 表格选中值
        handleSelectionChange(val) {
            this.multipleSelection = val;
            console.log(this.multipleSelection, "table 框选中的值");
            // console.log(this.table);
        },
        //全选
        speedupData() {
            var arr = this.multipleSelection;
            // console.log(arr, "全选后，获取的数组");
            let multis = [];
            for (var i = 0; i < arr.length; i++) {
                multis.push(arr[i].SEL_ID);
            }
            console.log(multis, "选中后的id");

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            console.log(sid);
            // let msg=JSON.stringify(multis)
            let __mode = "elk_spam_downzip";
            console.log(__mode);

            this.$refs.multipleTable1.clearSelection(); //操作完成清除勾选框
        },

        // 更多
        xians: function () {
            this.xian = !this.xian;

            if (this.xian) {
                this.geng = false;
                this.geng1 = true;
            } else {
                this.geng = true;
                this.geng1 = false;
            }
        },
        // 页面加载完成时，

        // 数据

        getFileList() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            let col = this.col;
            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/mon.cgi", {
                    params: {
                        __mode: "show_queue",
                        sid: sid,
                        col: col,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res);
                    // console.log(col, "传的col值");
                    this.col1 = this.col;
                    // console.log(this.col1, "传的col1值");
                    // console.log(this.page, '222')

                   if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        alert("请重新登录");
                        sessionStorage.removeItem("usermsg");
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                         this.limit_cn_old=res.data.ret.col.limit_cn
             this.printtype_arr = res.data.ret.q_printtype;
                        this.fileList = res.data.ret.datalist;
                        // 总条数
                        this.totalnums = res.data.ret.col.totalnums;
                        this.size = res.data.ret.col.pagesize;
                        this.page = res.data.ret.col.page;
                        // console.log(this.page)
                        this.minionhost = res.data.ret.q_minion_host;
                        // this.type1 = res.data.ret.q_spam_reason;
                        // 节点
                        this.minionhost = res.data.ret.q_minion_host;
                        //  类型
                        this.type1 = res.data.ret.q_type;
                        //  原因
                        this.spamreason = res.data.ret.q_spam_reason;
                        this.loading = false;
                            this.$nextTick(() => {
	this.$refs.multipleTable1.bodyWrapper.scrollTop = 0
})
                         this.col_search = res.data.ret.col
                        // console.log(this.col_search, '后台返回数据col,加载')
                        // for (let i = 0; i < this.fileList.length; ++i) {
                        //     this.fileList[i].SHOW_MORE = '展示更多'
                        // }
                        // var vm = this;
                        // 页面加载完成后渲染日期

                        // console.log(this.col.startdate);
                    }
                })
               
        },

        // 各行变色
        tableRowClassName({
            rowIndex
        }) {
            // console.log(row, rowIndex);
            // 各行变色
            if (rowIndex % 2 == 1) {
                return "warning-row";
                // console.log(2222)
            } else if (rowIndex % 2 !== 1) {
                return "success-row";
            }

            // 判断状态变色
            // if (row.SENT == 1) {
            //     return "sent1";
            // } else if (row.SENT == 0) {
            //     return "sent2";
            // }
            return "";
        },

        // 判断状态变色
        tableCellClassName({
            row
        }) {
            // console.log(row, rowIndex);

            if (row.SENT == 1) {
                return "sent1";
            } else if (row.SENT == 0) {
                return "sent2";
            }
            return "";
        },
        // 每页显示多少条 -- 切换
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
         

            this.col.pagesize = val;
            //  this.tanSend()

            // this.tanSend(this.search,this.pagesize)
            this.getFileList();

        },
            // 当前第几页
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
         
            this.col.page = val;
            //  this.tanSend(this.search,this.pagesize)
            // console.log(this.page, '1111', val);
            this.getFileList();
        },
        handleSizeChange2(val) {
            // console.log(`每页 ${val} 条`);
         
            this.col.pagesize = val;
            //  this.tanSend()
            this.loading_send=true;
            // this.tanSend(this.search,this.pagesize)
            this.save1();
        },
           handleCurrentChange2(val) {
            // console.log(`当前页: ${val}`);
           
            this.loading_send=true;

            this.col.page = val;
            //  this.tanSend(this.search,this.pagesize)
            // console.log(this.page, '1111', val);
            this.save1();
        },
        handleSizeChange3(val) {
         

            this.col.pagesize = val;
            //  this.tanSend()
            this.loading_send=true;

            // this.tanSend(this.search,this.pagesize)
            this.save2();
        },
        handleSizeChange4(val) {
            // console.log(`每页 ${val} 条`);
            this.col.pagesize = val;
            //  this.tanSend()

            // this.tanSend(this.search,this.pagesize)
            this.save3();
        },
    
     
        handleCurrentChange3(val) {
            // console.log(`当前页: ${val}`);
          
            this.col.page = val;
            this.loading_send=true;

            this.save2();

            //  this.tanSend(this.search,this.pagesize)
            // console.log(this.page, '2', val);
        },
        handleCurrentChange4(val) {
            // console.log(`当前页: ${val}`);
            this.col.page = val;
            this.save3();

            //  this.tanSend(this.search,this.pagesize)
            // console.log(this.page, '2', val);
        },
        // 打开详情页
        handleEdit(index, row) {
            // console.log(this.col1);
            console.log(index, row);
            // this.loading = false;

            this.$router.push({
                name: "guiDangListOne1",
                params: {
                    rec_id: row.REC_ID,
                    index: row.INDEX,
                    msgtype: row.MSGTYPE,
                    is_elk: 1,
                    col1: this.col1,
                },
            });
        },
        // 收件人展示更多

        handleEdit1(index, row) {
            console.log(row);
            this.fileList[index].SHOW_MORE =
                row.SHOW_MORE == `${this.$t("table.show")}` ?
                `${this.$t("table.yin")}` :
                `${this.$t("table.show")}`;
        },
    },
};
</script>

<style lang="less" scoped>

// /deep/ .sent1 .cell {
//     color: #16960e !important;
// }
/deep/ .sent2 .cell {
    color: #f00 !important;
}



// /deep/ .warning-row {

//     background: #F2F6FB;
// }

// /deep/ .success-row {

//     background: #fff;
// }

// 弹出框1
.pop-up1 {
    position: fixed;
    padding: 20px 20px;
    width: 20%;
    top: 30%;
    left: 50%;
    z-index: 102;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: white;
    margin-left: -12%;
}

.pop-up1 .table {
    display: flex;
    flex-direction: column;
    width: 90%;
    background: white;
    padding: 20px;
}

.pop-up1 .table div {
    width: 100%;
    padding: 5px 0;
}

.pop-up1 .el-input {
    width: 100%;
}

// 弹出框2
.pop-up2 {
    position: fixed;
    padding: 20px 20px;
    width: 20%;
    top: 30%;
    left: 50%;
    z-index: 102;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: white;
    margin-left: -12%;
}

.pop-up2 .table {
    display: flex;
    flex-direction: column;
    width: 90%;
    background: white;
    padding: 20px;
}

.pop-up2 .table div {
    width: 100%;
    padding: 5px 0;
}

.pop-up2 .el-input {
    width: 100%;
}

.gray {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: black;
    opacity: 0.6;
    z-index: 100;
}

// /deep/ .el-table__body tr:hover {
//     cursor: pointer;

// }

.biaodan {
    height: 300px;

    form {
        height: 300px;
    }
}

// @import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/liebiao.less";
@import "../../css/drag.less";

.pop-up .el-input {
    width: 100%;
}

/deep/.el-table__row td:nth-child(8) {
    .cell {
        text-align: center;
    }

}

/deep/.el-table__row td:nth-child(10) {
    .cell {
        text-align: left;
    }

}

.main .el-form {
    padding: 4px 0;
}

/deep/.el-table th {
    line-height: 26px;
}
/deep/.el-table__row td:nth-child(2) {
    .cell {
        padding-left: 0px;
        display: flex;
        justify-content: space-around;
    }

    
}

 /deep/  .table_one .has-gutter th:nth-child(4)  {
     .cell{
  text-align: left !important;

     }
}
 /deep/  .table_one .has-gutter th:nth-child(7)  {
     .cell{
  text-align: left !important;

     }
}
/deep/  .table_one .el-table__row td:nth-child(7) {
   .cell{
  text-align: left !important;

     }
}
/deep/  .table_one .has-gutter th:nth-child(9)  {
     .cell{
  text-align: left !important;

     }
}
/deep/  .table_one .el-table__row td:nth-child(9) {
   .cell{
  text-align: left !important;

     }
}
/deep/  .table_one .has-gutter th:nth-child(10)  {
     .cell{
  text-align: left !important;

     }
}
/deep/  .table_one .el-table__row td:nth-child(10) {
   .cell{
  text-align: left !important;

     }
}
/deep/  .table_two .has-gutter th:nth-child(10) {
     .cell{
  text-align: center !important;

     }
}
/deep/  .table_two .el-table__row td:nth-child(10)  {
   .cell{
  text-align: center !important;

     }
}



/deep/  .table_three .has-gutter th {
     .cell{
  text-align: left !important;

     }
}
/deep/  .table_three .el-table__row td {
   .cell{
  text-align: left !important;

     }
}
/deep/  .table_three .has-gutter th:nth-child(1) {
     .cell{
  text-align: center !important;

     }
}
/deep/  .table_three .el-table__row td:nth-child(1)  {
   .cell{
  text-align: center !important;

     }
}
/deep/  .table_three .has-gutter th:nth-child(2) {
     .cell{
  text-align: center !important;

     }
}
/deep/  .table_three .el-table__row td:nth-child(2)  {
   .cell{
  text-align: center !important;

     }
}
</style>
